import { render, staticRenderFns } from "./issues.vue?vue&type=template&id=f09b3abc&scoped=true"
import script from "./issues.vue?vue&type=script&lang=js"
export * from "./issues.vue?vue&type=script&lang=js"
import style0 from "./issues.vue?vue&type=style&index=0&id=f09b3abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09b3abc",
  null
  
)

export default component.exports